package com.mencanhealth.admin.ui

import androidx.compose.runtime.*
import com.mencanhealth.admin.data.AdminFirestoreService
import com.mencanhealth.admin.model.AdminUser
import com.mencanhealth.admin.model.SubscriptionTier
import com.mencanhealth.admin.ui.components.TierBadge
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
fun UsersPage(
    firestoreService: AdminFirestoreService,
    onSelectUser: (String) -> Unit
) {
    var users by remember { mutableStateOf<List<AdminUser>>(emptyList()) }
    var search by remember { mutableStateOf("") }
    var filterTier by remember { mutableStateOf<SubscriptionTier?>(null) }
    var loading by remember { mutableStateOf(true) }
    val scope = rememberCoroutineScope()

    LaunchedEffect(Unit) {
        users = firestoreService.listUsers()
        loading = false
    }

    val filtered = users.filter { user ->
        val matchesSearch = search.isBlank() ||
            user.email.contains(search, ignoreCase = true) ||
            (user.displayName?.contains(search, ignoreCase = true) == true)
        val matchesTier = filterTier == null || user.tier == filterTier
        matchesSearch && matchesTier
    }

    Div({ classes("page") }) {
        H2 { Text("Users") }

        Div({ classes("toolbar") }) {
            Input(InputType.Text) {
                classes("search-input")
                value(search)
                attr("placeholder", "Search by email or name...")
                onInput { search = it.value }
            }
            Div({ classes("filter-chips") }) {
                Button({
                    classes("chip"); if (filterTier == null) classes("chip-active")
                    onClick { filterTier = null }
                }) { Text("All") }
                SubscriptionTier.entries.forEach { tier ->
                    Button({
                        classes("chip"); if (filterTier == tier) classes("chip-active")
                        onClick { filterTier = tier }
                    }) { Text(tier.name) }
                }
            }
        }

        if (loading) {
            P { Text("Loading users...") }
        } else {
            Div({ classes("user-count") }) { Text("${filtered.size} users") }
            Table({ classes("data-table") }) {
                Thead {
                    Tr {
                        Th { Text("Email") }
                        Th { Text("Name") }
                        Th { Text("Tier") }
                        Th { Text("Actions") }
                    }
                }
                Tbody {
                    filtered.forEach { user ->
                        Tr({
                            classes("clickable-row")
                            onClick { onSelectUser(user.uid) }
                        }) {
                            Td { Text(user.email) }
                            Td { Text(user.displayName ?: "-") }
                            Td { TierBadge(user.tier) }
                            Td {
                                Button({
                                    classes("btn-small")
                                    onClick { onSelectUser(user.uid) }
                                }) { Text("View") }
                            }
                        }
                    }
                }
            }
        }
    }
}
